import { render, staticRenderFns } from "./EditSearchTemplate.vue?vue&type=template&id=1dab4840&scoped=true&"
import script from "./EditSearchTemplate.vue?vue&type=script&lang=js&"
export * from "./EditSearchTemplate.vue?vue&type=script&lang=js&"
import style0 from "./EditSearchTemplate.vue?vue&type=style&index=0&id=1dab4840&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dab4840",
  null
  
)

export default component.exports